import { SWReactIcons } from "@similarweb/icons";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { StyledButtonWrap, StyledText } from "./styles";

type SelectionDropdownButtonProps = {
    text: Readonly<Translatable>;
    isDisabled?: boolean;
    onClick(): void;
};

function SelectionDropdownButton(props: SelectionDropdownButtonProps) {
    const { text, isDisabled = false, onClick } = props;

    function handleClick() {
        if (!isDisabled) {
            onClick();
        }
    }

    return (
        <StyledButtonWrap
            onClick={handleClick}
            isDisabled={isDisabled}
            data-automation="selection-dropdown-button"
            data-automation-disabled={isDisabled}
        >
            <I18n
                element={StyledText}
                data-automation="selection-dropdown-button.text"
                translatable={text}
            />
            <SWReactIcons iconName="arrow" />
        </StyledButtonWrap>
    );
}

export default SelectionDropdownButton;
